import script from "./MultiPreJob.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiPreJob.vue?vue&type=script&setup=true&lang=js"

import "./MultiPreJob.vue?vue&type=style&index=0&id=778c825d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-778c825d"]])

export default __exports__